import domReady from '@wordpress/dom-ready';
import tippy from 'tippy.js';

const setTooltips = () => {
	const comparisonListItemSelector = '.js-block-expandable-pricing-section-item-title';

	const comparisonListItems = document.querySelectorAll(`${comparisonListItemSelector}[data-tooltip]`);

	if (!comparisonListItems.length) {
		return;
	}

	comparisonListItems.forEach((item) => {
		if (item?.dataset?.tooltip?.length > 0) {
			tippy(item, {
				content: item?.dataset?.tooltip ?? '',
				animation: 'shift-away',
				theme: 'translucent productive',
				maxWidth: 240,
			});
		}
	});
};

const setupSectionTriggers = async () => {
	const sectionTriggerSelector = '.js-block-expandable-pricing-section-trigger';
	const sectionTriggers = document.querySelectorAll(sectionTriggerSelector);

	if (!sectionTriggers.length) {
		return;
	}

	const { ExpandableSection } = await import('./expandable-section');

	sectionTriggers.forEach((sectionTrigger) => {
		const expandableSection = new ExpandableSection({
			sectionTrigger,
			sectionTriggerSelector,
		});
		expandableSection.init();
	});
};

domReady(async () => {
	const blockContainerElements = document.querySelectorAll('.js-block-expandable-pricing-panel-container');

	if (!blockContainerElements.length) {
		return;
	}

	setTooltips();
	setupSectionTriggers();

	const { CollapsablePricing } = await import('./collapsable-pricing');

	[...blockContainerElements].forEach((pricingElement) => {
		const panel = new CollapsablePricing({
			pricingElement,
			collapsableTriggerSelector: '.js-block-expandable-pricing-collapsable-trigger',
			panelElementSelector: '.js-block-expandable-pricing-panel-content',
		});

		panel.init();
	});
});
